import { Component, Input, OnInit } from '@angular/core';
import { ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-ssn-trace-manager',
  templateUrl: './ssn-trace-manager.component.html',
  styleUrls: ['./ssn-trace-manager.component.less']
})
export class SsnTraceManagerComponent implements OnInit {
  ngOnInit(): void {
    this.appData.GetSSNTraceForApplicant(this.pkg.searchEntryId);
  }
  @Input() pkg : ScreeningAdditionalData;

  constructor(public appData : ApplicantDataService, public auth : AuthService){}
}
